/**
 * @copyright Copyright 2019 Epic Systems Corporation
 * @file reset reducer for async state
 * @author Roland Scott
 * @module react-async-hook\internal\state\reducers\reset
 */

import { IAsyncState } from "../types";

/**
 * Reset the async state
 * @return A new, blank async state.
 */
export function reset(): IAsyncState {
	return {
		ids: [],
		executions: {},
	};
}
